import { graphql, useStaticQuery } from "gatsby"
import find from "lodash/find"
import { urlHelper } from "../util"
import { imageItemTransformer } from "../utils/transformers"
import Image from "./ImageOptim"
import Link from "./LinkWrapper"

const AnniversaryLogo = ({ className, currentLanguage }) => {
  const { timelinePages, logos } = useStaticQuery(
    graphql`
      query AnniversaryArticle {
        timelinePages: allKontentItemTimelinePage(
          filter: {
            system: {
              codename: {
                eq: "timeline_page"
              }
            }
          }
        ) {
          nodes {
            preferred_language
            resolved_url
          }
        }
        logos: allKontentItemImageElement(
          filter: {
            system: { codename: { eq: "image___intralox_50_footer_logo" } }
          }
        ) {
          nodes {
            ...Image
          }
        }
      }
    `
  )

  const translatedTimelinePage = find(
    timelinePages.nodes,
    (timelinePage) => timelinePage.preferred_language === currentLanguage
  )
  const translatedLogo = find(
    logos.nodes,
    (logo) => logo.preferred_language === currentLanguage
  )
  const imageProps = imageItemTransformer(translatedLogo)

  return (
    <Link to={urlHelper(translatedTimelinePage)} className={`${className} block max-w-full`} style={{width: Math.ceil(imageProps.width / 2)}}>
      <Image
        {...imageProps}
        cropWidth={Math.ceil(imageProps.width / 2)}
      />
    </Link>
  )
}

export default AnniversaryLogo
